<div class="pointCF__field pointCF__field--expandable">
  <label class="pointCF__label">
    <div class="pointCF__label-image--container">
      @if (ppVolyActive === EIntegrationStatus.OFF) {
        <pp-icon [ppSrc]="EIconPath.ICON_FIELDS_COST_18" ppColor="inherit" ppClass="setSize18" />
      }
      @if (ppVolyActive === EIntegrationStatus.ON) {
        <img
          [src]="EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_BIG"
          ppTooltip
          [ppTitle]="'custom_field_voly_tooltip' | ppTranslate"
        />
      }
      @if (ppVolyActive === EIntegrationStatus.DISABLED) {
        <img
          [src]="EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_BIG"
          ppTooltip
          [ppTitle]="'custom_field_voly_disabled_tooltip' | ppTranslate"
        />
      }
    </div>

    <span
      ppTooltip
      class="pointCF__label-container"
      ppTitle="{{ ppFieldLabel }}"
      [ppTrimTooltip]="true"
    >
      {{ ppFieldLabel }}
    </span>

    @if (ppFieldDescription) {
      <pp-point-fields-custom-field-description [ppDescription]="ppFieldDescription" />
    }
  </label>

  @if (ppSubfieldsActive) {
    <pp-custom-field-numeric-with-subfields
      [ppPointField]="ppPointCustomField"
      [ppFieldId]="ppFieldId"
      [ppWorkspaceId]="ppWorkspaceId"
      [ppCanEdit]="ppCanEdit"
      [ppPointId]="ppPointId"
      [ppNew]="ppNew"
      [ppIsLocked]="ppIsLocked"
    />
  } @else {
    <pp-custom-field-cost
      [ppWorkspaceId]="ppWorkspaceId"
      [ppPointId]="ppPointId"
      [ppFieldId]="ppFieldId"
      [ppFieldLabel]="ppFieldLabel"
      [ppFieldCurrencySymbol]="ppFieldCurrencySymbol"
      [ppFieldCurrencyCode]="ppFieldCurrencyCode"
      [ppCurrencyName]="currencyName"
      [ppFieldValue]="ppPointCustomField?.value"
      [ppIntegrationStatus]="ppVolyActive"
      [ppNew]="ppNew"
      [ppCanEdit]="ppCanEdit"
      (ppUpdate)="updateField($event)"
      [ppDecimalPlaces]="2"
      [ppIsLocked]="ppIsLocked"
    />
  }
</div>
